import React, { useLayoutEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import BackToTop from '../../assets/images/back-to-top.svg';
import './index.scss';

const ScrollToTop = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisibility = () => {
    if (window && window.pageYOffset > 400) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useLayoutEffect(() => {
    document.addEventListener('scroll', () => {
      toggleVisibility();
    });
    return () => {
      document.removeEventListener('scroll', null);
    };
  }, []);

  return (
    <div className="scroll-to-top">
      {visible && (
      <Button variant="danger" size="sm" onClick={scrollToTop}>
        <img src={BackToTop} alt="bacl to top" />
      </Button>
      )}
    </div>
  );
};

export default ScrollToTop;
